import React from 'react';
import { FeedDataset } from '../types/Feed';
import './DatasetSelector.css';

interface DatasetSelectorProps {
  datasets: FeedDataset[];
  selectedDatasetId: string | null;
  onDatasetSelect: (datasetId: string) => void;
}

const DatasetSelector: React.FC<DatasetSelectorProps> = ({
  datasets,
  selectedDatasetId,
  onDatasetSelect
}) => {
  // Only show selector if there's more than one dataset
  if (datasets.length <= 1) {
    return null;
  }

  if (datasets.length === 0) {
    return (
      <div className="dataset-selector">
        <p className="no-datasets">Brak dostępnych datasetów</p>
      </div>
    );
  }

  return (
    <div className="dataset-selector">
      <label htmlFor="dataset-dropdown" className="dataset-label">
        Wybierz dataset:
      </label>
      <select
        id="dataset-dropdown"
        className="dataset-dropdown"
        value={selectedDatasetId || ''}
        onChange={(e) => onDatasetSelect(e.target.value)}
      >
        <option value="">-- Wybierz dataset --</option>
        {datasets.map((dataset) => (
          <option key={dataset.id} value={dataset.id} title={dataset.description.pl}>
            {dataset.title.pl} ({dataset.resources.length} rekordów)
          </option>
        ))}
      </select>
    </div>
  );
};

export default DatasetSelector;
